module.exports = __webpack_public_path__ + "static/img/tpm.a04a529.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tpm.jpg
// module id = 6QUR
// module chunks = 1